import { ProductsDTO } from "./TitleSearch.service";
import { HttpClient } from "@angular/common/http";
import { BehaviorSubject } from "rxjs";
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from "../../environments/environment";
import { Inject, Injectable } from "@angular/core";
import { BaseService } from "./base.service";

export interface ILastUsed {
	products: ProductsDTO[]
}

export const EMPTY_LAST_USED = {
	products: []
};

@Injectable({
	providedIn: 'root'
})
export class LastUsedService extends BaseService<any> {
	private _lastUsed$: BehaviorSubject<ILastUsed> = new BehaviorSubject<ILastUsed>(EMPTY_LAST_USED)

	constructor(
		private httpClient: HttpClient,
		private spinnerService: NgxSpinnerService,
		@Inject(HttpClient) http
	) {
		super(http);
	}

	get lastUsed$() {
		return this._lastUsed$.asObservable();
	}

	loadLastUsed(category: string) {
		this.spinnerService.show();
		const URI = environment.API_ENDPOINT + environment.VERSION_V1 + environment.API_ROUTES.BUYER.LAST_USED.GET + `?category=${category}`;
		this.httpClient.get<ILastUsed>(URI).subscribe((lastUsed) => {
			this._lastUsed$.next(lastUsed);
			this.spinnerService.hide();
		}, (error) => {
			this.spinnerService.hide();
		});
	}

	addProductToLastUsed(id: string) {
		const URI = environment.API_ENDPOINT + environment.VERSION_V1 + environment.API_ROUTES.BUYER.LAST_USED.UPDATE;
		const payload = {
			product: id
		};
		this.put(URI, payload).subscribe();
	}
}
